<template>
  <div class="language-selector" role="group" aria-label="Language">
    <button class="language-selector__button" :class="{ 'language-selector__button--active': langcode === 'en' }"
      type="button" aria-label="English" @click="setLanguage('en')">
      <img class="language-selector__flag" :src="englishFlag" alt="" />
    </button>
    <button class="language-selector__button" :class="{ 'language-selector__button--active': langcode === 'no' }"
      type="button" aria-label="Norsk" @click="setLanguage('no')">
      <img class="language-selector__flag" :src="norwegianFlag" alt="" />
    </button>
  </div>
</template>


<script>
import { getPreferredLocale, setStoredLocale } from "@/plugins/i18n/config";
import englishFlag from "@/assets/lang/en.png";
import norwegianFlag from "@/assets/lang/no.png";

export default {
  name: "LanguageSelector",
  props: {},
  components: {},

  data() {
    return {
      englishFlag,
      langcode: getPreferredLocale(),
      norwegianFlag,
    };
  },

  mounted() {},

  methods: {
    setLanguage(languageCode = this.langcode) {
      this.langcode = setStoredLocale(languageCode);
      window.location.reload();
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang="scss" scoped>
.language-selector {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.language-selector__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 30px;
  padding: 3px;
  border: 2px solid transparent;
  border-radius: 5px;
  background: transparent;
  cursor: pointer;
  opacity: 0.62;
}

.language-selector__button--active {
  border-color: var(--v-primary-base);
  opacity: 1;
}

.language-selector__flag {
  display: block;
  width: 30px;
  height: 20px;
  object-fit: cover;
}
</style>